import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch, } from "vue-property-decorator";
import { Progress, Icon, Tooltip } from "@h3/antd-vue";
import { UploadStatus } from "../../../src/common/controls/upload-control";
import Axios from 'axios';
let FileList = class FileList extends Vue {
    constructor() {
        super(...arguments);
        this.precents = [];
        this.status = []; // 保存单个文件状态
        this.timer = 0;
        this.nameWidth = 0;
        /**
         * @desc 处理时间
         */
        this.format = function (time, format = "YYYY-MM-dd HH:mm:sss") {
            let t = new Date(time);
            let o = {
                "M+": t.getMonth() + 1,
                "d+": t.getDate(),
                "H+": t.getHours(),
                "m+": t.getMinutes(),
                "s+": t.getSeconds(),
                "q+": Math.floor((t.getMonth() + 3) / 3),
                "f+": t.getMilliseconds(),
            };
            if (/(Y+)/.test(format)) {
                format = format
                    .replace(RegExp.$1, t.getFullYear() + "")
                    .substr(4 - RegExp.$1.length);
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length));
                }
            }
            return format;
        };
    }
    get isCrossEntityWorkflow() {
        let temp = sessionStorage.getItem('crossApplicant');
        if (!temp)
            return false;
        let crossApplicant = JSON.parse(temp);
        if (this.$route.query.workflowInstanceId === crossApplicant.workflowInstanceId) {
            return true;
        }
        else {
            return false;
        }
    }
    // 二开 COI 上传文件统一命名
    get isCOI() {
        let h3form = window.h3form;
        return h3form.formObj.bizObject.schemaCode === 'conflictOfInterests';
    }
    // 二开 E-CHOP 获取指定表单
    get isShowSort() {
        let h3form = window.h3form;
        return h3form.formObj.bizObject.schemaCode === 'sapfcpo_Chop' || h3form.formObj.bizObject.schemaCode === 'nonSAPDocChop' ? true : false;
    }
    // 二开 end
    eventListChange(arr = []) {
        // 跟新文件上传进度
        // console.log(arr, 'arr---');
        if (arr && arr.length > 0) {
            this.autoStep();
        }
    }
    removeFileBefore(file, key) {
        // financial 模块要求删除附件时弹框确认
        let financialForm = window.h3form.formObj.bizObject.schemaCode;
        if (financialForm === 'purchase_Request' ||
            financialForm === 'payment_application' ||
            financialForm === 'travelRequest' ||
            financialForm === 'travel_expense_claim' ||
            financialForm === 'local_travel_claim' ||
            financialForm === 'entertainment_requests' ||
            financialForm === 'entertainment_Expense_C' ||
            financialForm === 'special_approval_request' ||
            financialForm === 'marketing_pr' ||
            financialForm === 'chop_application' ||
            financialForm === 'fixed_asset_application') {
            window.h3form.$confirm({
                title: 'Confirm Dialog',
                content: `Are you sure you want to delete this file:${file.name}?`,
                onOk: () => {
                    this.removeFile(file, key);
                },
            });
        }
        else {
            this.removeFile(file, key);
        }
    }
    removeFile(file, key) {
        const res = Object.assign({}, file, { status: UploadStatus.Delete }) || null;
        if (this.precents && this.precents.length > 0) {
            this.precents = this.precents.filter((item, idx) => {
                return idx !== key;
            });
        }
        console.log(res, 'res');
        this.$emit('rmFile', res);
        // return res;
    }
    //  上移
    arrowUpFile(file, key) {
        // console.log("file-----",file)
        // console.log("key-----",key)
        this.$emit('changeFileListSort', key);
    }
    //  下移
    arrowDownFile(file, key) {
        // console.log("file-----",file)
        // console.log("key-----",key)
        this.$emit('changeFileListSortDown', key);
    }
    previewFile(file) {
        // console.log(file, 'file');
        this.$emit('previewFile', file);
    }
    /*
     * @desc 格式化文件大小
     */
    initSize(item) {
        if (item.size !== undefined) {
            let size = item.size;
            if (item.response && item.response.data && item.response.data.fileSize) {
                size = item.response.data.fileSize;
            }
            let k = 1024; // 比特 字节大小
            let m = 1048576; // 兆字节大小
            let num = k; // 默认使用的几算大小
            let str = "KB";
            if (size > m) {
                num = m;
                str = "M";
            }
            if (size === 0) {
                return `0${str}`;
            }
            else if (size) {
                return `${(size / num).toFixed(2)}${str}`;
            }
            else {
                return "";
            }
        }
        else if (item.fileSize !== undefined) {
            let size = item.fileSize;
            if (item.response && item.response.data && item.response.data.fileSize) {
                size = item.response.data.fileSize;
            }
            let k = 1024; // 比特 字节大小
            let m = 1048576; // 兆字节大小
            let num = k; // 默认使用的几算大小
            let str = "KB";
            if (size > m) {
                num = m;
                str = "M";
            }
            if (size === 0) {
                return `0${str}`;
            }
            else if (size) {
                return `${(size / num).toFixed(2)}${str}`;
            }
            else {
                return "";
            }
        }
    }
    getPercent(key) {
        let res = this.precents[key];
        if (!res)
            return 0;
        return res.percent;
    }
    getStatus(key) {
        if (!this.precents.length)
            return "done";
        let status = this.precents[key];
        if (status && status.status) {
            return this.transformStatus(status.status);
        }
        return "";
    }
    /**
     * @des 模拟更新进度条
     */
    autoStep() {
        // 防止开启多个定时器
        clearTimeout(this.timer);
        let isRpeat = false;
        this.precents = this.eventList.map((item, i) => {
            let { status, percent = 0, timer = -1, size = 0, response } = item;
            status = this.transformStatus(status);
            percent = this.getPercent(i);
            let step = 0;
            let ss = 300; // 默认每秒钟300k的上传速度
            if (status === "done" || status === "error") {
                percent = 100;
            }
            else {
                step = 100 / (size / ss / 1024);
                percent = percent + step;
                isRpeat = true;
            }
            // 状态更新
            if (response && !response.data) {
                status = "error";
            }
            return { percent, status };
        });
        // 调用自己
        if (isRpeat) {
            this.timer = window.setTimeout(this.autoStep, 1000);
        }
    }
    getColor(item) {
        if (item) {
            if (!this.precents.length)
                return "#17BC94";
            if (item.status === "error")
                return "#FF5500";
            return "#17BC94";
        }
    }
    getName(item) {
        if (item.hasOwnProperty("uploadName") && item.uploadName) {
            return item.uploadName;
        }
        if (item.response) {
            if (item.response.data.response) {
                return item.response.data.response.data.creater && item.response.data.response.data.creater.name;
            }
            else {
                return item.response.data.creater && item.response.data.creater.name;
            }
        }
        else if (item.creater) {
            // 关联映射
            if (item.creater.name) {
                return item.creater.name;
            }
        }
        return "";
    }
    getTime(item) {
        if (item.hasOwnProperty("uploadTime") && item.uploadTime) {
            return this.format(item.uploadTime);
        }
        if (item.response) {
            if (item.response.data.response) {
                return item.response.data.response.data.createdTime;
            }
            else {
                return item.response.data.createdTime;
            }
        }
        else if (item.createdTime) {
            return item.createdTime;
        }
        return "";
    }
    /**
     * @desc 下载文件
     */
    downFile(file, idx, actions) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (file.status === 2 || file.status === "done") {
                this.$emit('downloadChange', 'start');
                //根据refId 获取 下载url
                let url1 = '/api/oss/download/signurl';
                let params1 = {
                    refId: file.response.data.refId
                };
                let res1 = yield Axios.post(url1, params1);
                let downloadUrl = res1.data.signUrl;
                // let val = this.downUrls[idx];
                Axios({
                    url: downloadUrl,
                    method: 'get',
                    responseType: 'blob'
                }).then((res) => {
                    let binaryData = [];
                    // binaryData.push(res.data);
                    // console.log("binaryData----",binaryData)
                    // const url = window.URL.createObjectURL(new Blob(binaryData,{type:'application/octet-stream'}));
                    // let downloadName = file.name;
                    this.downloadFileUtil(file.name, res);
                    this.$emit('downloadChange', 'done');
                });
                event && event.stopPropagation();
                let h3form = window.h3form;
                if (h3form.formObj.bizObject.schemaCode === 'createOfferProposal' && (h3form.status.value === 'SAP Informed' || h3form.status.value === 'SAP Updated')) {
                    window.h3form.status.value = 'SAP Updated';
                }
            }
        });
    }
    downloadFileUtil(fileName, content) {
        const blob = new Blob([content]);
        // for IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName.replace(new RegExp('"', 'g'), ''));
        }
        else {
            const a = document.createElement('a');
            // 生成文件路径
            let href = window.URL.createObjectURL(blob);
            // let _fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            a.href = href;
            // 文件名中有中文 则对文件名进行转码
            a.download = decodeURIComponent(fileName.replace(new RegExp('"', 'g'), ''));
            // 利用a标签做下载
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
        }
    }
    initFieName(name) {
        let size = 14; // 字的大小
        let len = name.length * size;
        if (len <= this.nameWidth)
            return name;
        let start = name.slice(0, 6);
        let idex = name.lastIndexOf(".");
        let middle = name.slice(idex - 6, idex);
        let end = name.slice(idex);
        return `${start}...${middle}${end}`;
    }
    /**
     * @desc 获取组件的宽度
     */
    getWidth() {
        let size = 0;
        let el = document.querySelector(".file-list");
        if (el) {
            size = el.clientWidth;
        }
        this.nameWidth = Math.ceil(size * 0.7);
    }
    mounted() {
        this.getWidth();
        window.addEventListener("resize", this.getWidth);
        let { downUrls } = this;
        downUrls = downUrls ? downUrls : [];
        this.status = downUrls.map((item) => item.status);
    }
    transformStatus(status) {
        switch (status) {
            case UploadStatus.Delete:
                return "removed";
            case UploadStatus.Uploading:
                return "uploading";
            case UploadStatus.Done:
                return "done";
            case UploadStatus.Error:
                return "error";
            case UploadStatus.FileToImg:
                return "fileToImg";
            default:
                return status;
        }
    }
};
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "list", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], FileList.prototype, "showRm", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "downUrls", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], FileList.prototype, "eventList", void 0);
tslib_1.__decorate([
    Prop()
], FileList.prototype, "parentKey", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], FileList.prototype, "controlOpts", void 0);
tslib_1.__decorate([
    Watch("eventList")
], FileList.prototype, "eventListChange", null);
FileList = tslib_1.__decorate([
    Component({
        name: "file-list",
        components: {
            AProgress: Progress,
            AIcon: Icon,
            ATooltip: Tooltip,
        },
    })
], FileList);
export default FileList;
